class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById("cart-notification");
    this._isGiftingNow = false;
  }

  renderContents(parsedState) {
    var defaultEl = document.getElementById("cart-notification-default");
    if (defaultEl) defaultEl.innerHTML = "";
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      var el = document.getElementById(section.id);
      var sectionName = section.section || section.id;
      if (el && parsedState.sections && parsedState.sections[sectionName]) {
        var newHTML = this.getSectionInnerHTML(
          parsedState.sections[sectionName],
          section.selector,
        );
        if (newHTML !== null) el.innerHTML = newHTML;
      }
    });

    if (parsedState && parsedState.item_count !== undefined) {
      // Full cart response (from /cart/change.js, drawer updates, etc.)
      var itemCountEl = document.getElementById("cart-drawer-shared-item-count");
      var couponSection = document.getElementById("shopify-section-cart-drawer-coupons");

      if (parsedState.item_count === 0) {
        if (itemCountEl) itemCountEl.style.display = "none";

        // Inject attractive empty cart UI
        if (defaultEl) {
          defaultEl.innerHTML = '<div class="cart-empty-content">' +
            '<div class="cart-empty-illustration">' +
              '<svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="var(--border-primary)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
                '<circle cx="9" cy="21" r="1"></circle>' +
                '<circle cx="20" cy="21" r="1"></circle>' +
                '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>' +
              '</svg>' +
            '</div>' +
            '<h2 class="cart-empty-title">Your cart is empty</h2>' +
            '<p class="cart-empty-subtitle">Looks like you haven\'t added<br>anything to your cart yet.</p>' +
            '<a href="/collections/all" class="cart-empty-cta">' +
              '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                '<line x1="19" y1="12" x2="5" y2="12"></line>' +
                '<polyline points="12 19 5 12 12 5"></polyline>' +
              '</svg>' +
              'Start Shopping' +
            '</a>' +
          '</div>';
        }

        // Hide coupon widget when cart is empty
        if (couponSection) couponSection.style.display = "none";
      } else {
        if (itemCountEl) {
          itemCountEl.style.display = "inline";
          itemCountEl.textContent = "(" + parsedState.item_count + ")";
        }
        // Show coupon widget when cart has items
        if (couponSection) {
          couponSection.style.display = "";
          const widget = couponSection.querySelector('.cart-drawer__coupon-widget');
          if (widget) widget.classList.remove('is-empty');
        }
        
        // Ensure coupon data is updated based on new cart state
        if (typeof window.updateCouponWidget === 'function') window.updateCouponWidget();
        if (typeof window.renderCouponCards === 'function') window.renderCouponCards();
      }
      // Always keep the header cart-count-badge in sync
      if (typeof window.boldstuffUpdateCartCount === "function") {
        window.boldstuffUpdateCartCount(parsedState.item_count);
      }
    } else if (parsedState && parsedState.id) {
      // /cart/add.js item response — item_count is missing, fetch cart for true count
      fetch("/cart.js?v=" + new Date().getTime(), { credentials: "same-origin" })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          if (typeof window.boldstuffUpdateCartCount === "function") {
            window.boldstuffUpdateCartCount(cart.item_count || 0);
          }
          var itemCountEl = document.getElementById("cart-drawer-shared-item-count");
          if (itemCountEl && cart.item_count > 0) {
            itemCountEl.style.display = "inline";
            itemCountEl.textContent = "(" + cart.item_count + ")";
          }
          // Show coupon widget when adding an item
          var couponSection = document.getElementById("shopify-section-cart-drawer-coupons");
          if (couponSection && cart.item_count > 0) {
            couponSection.style.display = "";
            const widget = couponSection.querySelector('.cart-drawer__coupon-widget');
            if (widget) widget.classList.remove('is-empty');
            
            if (typeof window.updateCouponWidget === 'function') window.updateCouponWidget();
            if (typeof window.renderCouponCards === 'function') window.renderCouponCards();
          }
        })
        .catch(function () {});
    }

    // Trigger Free Gift Logic check
    this.checkFreeGift();

    var dropDownIcon = document.querySelector("#cart-icon-bubble");
    if (dropDownIcon && dropDownIcon.getAttribute("aria-expanded") == "false") {
      dropDownIcon.click();
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
      },
      {
        id: "cart-notification-button",
      },
      {
        id: "cart-upsell",
      },
      {
        id: "cart-drawer-gift",
      },
      {
        id: "shopify-section-cart-drawer-coupons",
        section: "cart-drawer-coupons",
        selector: null
      }
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    var parsed = new DOMParser().parseFromString(html, "text/html");
    if (!selector) return parsed.body.innerHTML;
    var el = parsed.querySelector(selector);
    return el ? el.innerHTML: parsed.body.innerHTML;
  }

  // --- START FREE GIFT LOGIC ---
  checkFreeGift(cartData = null) {
    if (this._isGiftingNow) return;

    const processCartForGift = (cart) => {
      const triggerProductHandle = "boldstuff-bronze-1-7l";
      const giftProductHandle = "boldstuff-500ml";

      const hasTrigger = cart.items.some(
        (i) => i.handle === triggerProductHandle,
      );
      const giftInCart = cart.items.find((i) => {
        return (
          i.handle === giftProductHandle &&
          i.properties &&
          i.properties._is_free_gift === "true"
        );
      });

      if (hasTrigger && !giftInCart) {
        this._isGiftingNow = true;
        this.addFreeGiftItem();
      } else if (!hasTrigger && giftInCart) {
        this._isGiftingNow = true;
        // Trigger NOT found, Gift found -> Remove Gift instantly
        this.removeFreeGiftItem(giftInCart.key);
      }
    };

    if (cartData && cartData.items) {
      processCartForGift(cartData);
    } else {
      fetch("/cart.js?v=" + new Date().getTime(), { cache: "no-store" })
        .then((r) => r.json())
        .then(processCartForGift)
        .catch((e) => console.error("Free Gift Check Error: ", e));
    }
  }

  addFreeGiftItem() {
    fetch("/products/boldstuff-500ml.js")
      .then((r) => r.json())
      .then((product) => {
        const variantId = product.variants[0].id;
        const sectionsToRender = this.getSectionsToRender().map((s) => s.section || s.id);

        let formData = {
          items: [
            {
              id: variantId,
              quantity: 1,
              properties:  { _is_free_gift: "true" },
            },
          ],
          sections: sectionsToRender,
        };

        return fetch("/cart/add.js", {
          method: "POST",
          headers:  { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });
      })
      .then((r) => r.json())
      .then((parsedState) => {
        // Clear any stuck manual discounts that conflict with automatic ones
        return fetch("/cart/update.js", {
          method: "POST",
          headers:  { "Content-Type": "application/json" },
          body: JSON.stringify({ discount: "", sections: this.getSectionsToRender().map((s) => s.section || s.id) }),
        }).then(r => r.json()).catch(() => parsedState);
      })
      .then((parsedState) => {
        this._isGiftingNow = false;
        // Re-render drawer to show the gift
        this.renderContents(parsedState);
        this.showGiftNotification("Yay! Free 500ML bottle added to your cart! 🎁");
      })
      .catch((e) => {
        console.error("Add Free Gift Error: ", e);
        this._isGiftingNow = false;
      });
  }

  removeFreeGiftItem(variantKey) {
    const sectionsToRender = this.getSectionsToRender().map((s) => s.section || s.id);
    let formData = {
      updates:  { [variantKey]: 0 },
      sections: sectionsToRender,
    };

    fetch("/cart/update.js", {
      method: "POST",
      headers:  { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then((r) => r.json())
      .then((parsedState) => {
        this._isGiftingNow = false;
        this.renderContents(parsedState);
      })
      .catch((e) => {
        console.error("Remove Free Gift Error: ", e);
        this._isGiftingNow = false;
      });
  }

  showGiftNotification(msg) {
    const banner = document.createElement("div");
    banner.className = "gift-notification-banner";
    banner.innerHTML = `<span class='gift-icon'>🎁</span> ${msg}`;
    document.body.appendChild(banner);

    setTimeout(() => banner.classList.add("visible"), 100);
    setTimeout(() => {
      banner.classList.remove("visible");
      setTimeout(() => banner.remove(), 5000);
    }, 4000);
  }
}

customElements.define("cart-notification", CartNotification);
